export default process.env.USER_ROLES_API_BASE ||
  (process.env.NODE_ENV === "production"
    ? "/api/user-roles/"
    : "http://localhost:55093/");
